<template>
  <main class="flex-shrink-0">
    <the-header></the-header>

    <router-view v-slot="slotProps">
      <transition name="route" mode="out-in">
        <component :is="slotProps.Component"></component>
      </transition>
    </router-view>
  </main>
  <the-footer></the-footer>
</template>

<script>
import TheHeader from "./components/layouts/TheHeader.vue";
import TheFooter from "./components/layouts/TheFooter.vue";

export default {
  components: {
    TheHeader,
    TheFooter,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap");
@import "~bootstrap-icons/font/bootstrap-icons.css";

* {
  font-family: "Roboto", sans-serif;
  /* font-size: 14px; */
  /* font-size: 0.875rem; */
}

/* HTML ELEMENTS */

body {
  font-family: "Roboto", sans-serif;
  background-color: whitesmoke;
  color: #0c120c;
  margin: 0;
}

h1,
h2,
h3 {
  color: #242b83;
}

p {
  line-height: 1.5;
}

ul {
  line-height: 1.5;
}

hr {
  border: dotted #7f95d1 6px;
  border-bottom: none;
  width: 3%;
  margin: 40px auto;
  color: transparent !important;
  opacity: 1;
}

h1 + hr {
  border-style: none;
  height: 3px !important;
  background-image: linear-gradient(90deg, #f8b136 0%, #e6037e 100%);
  border: none;
  width: 100%;
  margin: 0px auto;
}

a {
  color: #242b83;
  text-decoration: none;
}

p > a {
  color: #242b83;
  font-weight: bold;
}

/* CLASSES */

/*override bootstrap navbar*/
.navbar {
  background-color: #242b83;
}

/* top section */

.top-container {
  background-color: #242b83;
  color: whitesmoke;
}

.banner-div {
  padding: 0 15% 20px 15%;
  text-align: center;
}

.title-div {
  text-align: center;
  display: inline-block;
  padding: 20px;
  margin: auto;
}

.button-custom-span {
  font-weight: bold;
}

.feed-div {
  text-align: center;
  display: inline-block;
  padding: 20px;
  margin: auto;
  height: auto;
}

.archivio-vivo-logo {
  width: 380px;
}
.maintitle {
  font-size: 2.5rem;
  color: whitesmoke;
}
.vivofont {
  font-weight: bolder;
}
.subtitle {
  color: whitesmoke;
  font-weight: normal;
}

/* bottom arrow */
.separator {
  text-align: center;
}

#bottom-arrow {
  opacity: 1;
  color: #242b83;
  font-weight: bolder;
  font-size: 3rem;
}

#bottom-arrow:hover {
  opacity: 0.8;
}

/* info section */

.info-row {
  width: 70%;
  margin: 20px auto 20px auto;
}

.section-row {
  width: 70%;
  margin: 20px auto 20px auto;
}

@media (max-width: 992px) {
  .info-row {
    width: 100%;
  }
}

#informations {
  padding-top: 10px;
}

.section-title {
  margin-top: 50px;
}

.section-text {
  margin-top: 40px;
}

/* bottom section */

#partners {
  width: 70%;
  text-align: center;
  margin: 20px auto 20px auto;
}
.partner-ul {
  margin: auto;
}
.partner-li {
  display: inline-block;
  height: 200px;
  width: 200px;
}
.partner-logo {
  max-height: 150px;
  max-width: 100%;
}
.footer-row {
  text-align: center;
}

/* images */

.custom-card {
  max-width: 450px;
}

.section-img-right {
  float: right;
  width: 300px;
}

.section-img-left {
  float: left;
  width: 300px;
}

.section-img-center {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 50px;
}

/* route link transition */
.route-enter-from {
}
.route-leave-to{
  opacity: 0;
}
.route-enter-active {
  transition: opacity 0.3s ease-out;
}
.route-enter-to {
}
.route-leave-active {
  transition: opacity 0.3s ease-in;
}

@media (max-width: 768px) {
  .section-img-right {
    float: none;
    width: 100%;
  }
  .section-img-left {
    float: none;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .section-img-center {
    max-width: 800px;
  }
}
</style>
